/**
 * 认证管理 成绩导入
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool,utils_tool } from '@/tool'
import { ExportExcel } from '../../../../components/index'
import { modelUtils } from '../../../../utils'
import logger from "less/lib/less/logger";
let { WizTypography, WizSpin, WizModal} = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
let { excelUtils, Session } = utils_tool;
class RemoteAuthScoreFileImport extends WizContainer {

  componentName = 'remoteAuthScoreFileImport';

  constructor(props) {
    super(props);
    let initialValue = {};
    if (props.history.location && props.history.location.pathname === '/remoteAuth/remoteAuthList/remoteAuthScoreFileImport') {
      if (props.history.location && props.history.location.record) {
        initialValue = props.history.location.record;
        Session.set('remoteAuthImport', initialValue)
      } else {
        initialValue = Session.get('remoteAuthImport') || {};
      }
    }
    this.initialValue = initialValue;
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['remoteAuthScore']
    if (o['success']) {
      if (o.code && o.code == 100003 ){
        WizModal.confirm({
          title: "注意",
          content:<p style={{whiteSpace: "pre-line"}}>{o.msg.replace(/<br\/>/g,"\n")}</p>,
          onOk: () => {
              let apiPath = 'studentRemoteAuthDetail/importScore';
              this.doAction({
                path: apiPath,
                payload: {
                  key: "import",
                  apiParams: {
                    fileData : this.state.fileData,
                    remoteAuthId : this.initialValue.id,
                    disPose : true
                  }
                }
              });
          },
          onCancel() { },
        });
      }else{
        let data = o['data'];
        let str = data.replace(/<br\/>/g,"\n")
        WizModal.success({
          title:'导入结果',
          content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
        })
      }
      return true;
    } else {
      wizNotice.error(o.msg)
      //wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    remoteAuthScore: this._handldImport.bind(this),
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '认证管理成绩导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_remoteAuthScoreFileImport,
      }

    }
    let submit = (file, fileData) => {
      this.setState({fileData : fileData});
      let apiPath = 'studentRemoteAuthDetail/importScore';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,remoteAuthId:this.initialValue.id
          }
        }
      });
    }
    let { remoteAuthScoreLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={remoteAuthScoreLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentRemoteAuthDetail } = state;
  const scoreImport = modelUtils.getModelEntity(studentRemoteAuthDetail, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'remoteAuthScore')
  return {
    remoteAuthScore: scoreImport,
    ...load
  }
};

export default connect(mapStateToProps)(RemoteAuthScoreFileImport);
